import React from "react";
import { useRouter } from "next/router";
import { GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import { Website } from "@/types/website";
import Layout from "@/components/Page/Layout";
import Article from "@/components/News/Article";
import { serverSidePage } from "@/utils/serverSide";
import { Article as ArticleType } from "@/types/office";
import { getArticleLocale } from "@/components/News/Excerpt";

type Props = {
  website: Website;
  article: ArticleType;
};

export const ArticlePage = ({ article }: Props): React.ReactElement => {
  const router = useRouter();
  const { locale = "pl" } = router;

  const articleLocale = getArticleLocale(article, null, locale);

  if (!article) return null;

  return <Article article={article} rounded={false} locale={articleLocale} />;
};

ArticlePage.getLayout = function getLayout(page: React.ReactElement) {
  const router = useRouter();
  const { locale = "pl" } = router;
  const { website, article } = page.props;

  const articleLocale = getArticleLocale(article, null, locale);

  return (
    <Layout
      title={article?.webTopic?.[articleLocale]}
      website={website}
      noHeading
    >
      {page}
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  query,
  req,
}) => ({
  props: {
    ...(await serverSidePage(query, req)),
    ...(await serverSideTranslations(locale, ["common"])),
  },
});

export default ArticlePage;
